import { render, staticRenderFns } from "./ReservaProvinciale.vue?vue&type=template&id=66a4ef29&lang=pug"
import script from "./ReservaProvinciale.vue?vue&type=script&lang=js"
export * from "./ReservaProvinciale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports